<div class="bolide-loader-container">
    <canvas ref="npi_loader_canvas"></canvas>
</div>